import { GET_RATE_TYPE_LISTS, GET_RATE_TYPE_LISTS_REQUEST, GET_RATE_SCHEDULE_LISTS, GET_RATE_SCHEDULE_LISTS_REQUEST } from '../constants/action-types';

const initialState = {
  farmId: null,
  isRequesting: false,
  rateTypeList: [],
  rateScheduleList: [],
  isRateRequesting: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RATE_TYPE_LISTS_REQUEST:
      state = {
        ...state,
        isRequesting: true,
        rateTypeList: []
      }
      break;
    case GET_RATE_TYPE_LISTS:
      state = {
        ...state,
        isRequesting: false,
        rateTypeList: [...action.payload],
      };
      break;
      case GET_RATE_SCHEDULE_LISTS_REQUEST:
      state = {
        ...state,
        isRateRequesting: true,
        rateScheduleList: []
      }
      break;
    case GET_RATE_SCHEDULE_LISTS:
      state = {
        isRateRequesting: false,
        rateScheduleList: [...action.payload],
      };
      break;
    default:
      break;
  }
  return state;
};
